<template>
<footer class="iprt-download-footer">
  <div class="flex flex-col items-center justify-center mt-4">
    <div class="flex flex-col  justify-center center item-center">
      <span> Copyright © 2016-2021 All Rights Reserved. &nbsp;&nbsp;</span>
      <img class="inline-block mt-2" style="vertical-align: middle; width: 300px;" src="../../assets/images/common/logo_group.png">
    </div>
    <p class="beian mt-2"><a href="https://beian.miit.gov.cn/" target="_blank"> 备案号： 浙ICP备16033261号-1</a></p>
  </div>
</footer>
</template>